import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getRegisterRoleSelector } from '../../../../../../../store/auth/selector';

type Params = {
  name: string;
};

export function useViewModel(params: Params) {
  const formik = useFormikContext<any>();
  const role = useSelector(getRegisterRoleSelector);

  useEffect(() => {
    formik.setFieldValue(params.name, role, false);
  }, [role]);
}
